<template>
	<div>
		<nk-multichoice2 ref="dropdown" :model-value="dropdownValue" :data="toursList" :options="dropdownOptions" @update:modelValue="updateModelValue" :tabindex="tabindex" :disabled="isDisable ? true : null"></nk-multichoice2>
	</div>
</template>

<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import $sc from '~/plugins/shortcut.collection.js'
	import TourModify from '~/views/capillary/tour-definition/visit-tour/tour-modify.vue'
	import TourList from '~/views/capillary/tour-definition/visit-tour/index.vue'

	export default {
		name: 'dropdown-tour-list',
		props: {
			data: { type: Array },
			modelValue: {},
			options: { type: Object },
			disabled: { type: Boolean, default: false },
			tabindex: {},
			selectorHeight: { type: String, default: '50%' },
		},
		emits: ['update:modelValue'],
		data() {
			return {
				toursList: [],
				settings: {},
				localValue: null,
				componentMounted: false,
				addTourBtn: {
					title: this.$t('capillary.tour.buttons.addTour'),
					shortcut: $sc.find('ctrl-insert'),
					isPrimary: false,
					element: () => { return this.$el },
					icon: 'plus',
					handle: (button, page, e) => {
						this.showTourModify()
					}
				},
				listTourBtn: {
					title: this.$t('list'),
					shortcut: $sc.find('enter'),
					isPrimary: true,
					element: () => { return this.$el },
					icon: 'list-ul',
					handle: (button, page, e) => {
						this.showTourList()
					}
				},
			}
		},
		computed: {
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.localValue = val
					this.$emit('update:modelValue', val)

					if (this.settings.onChangeHandler && typeof this.settings.onChangeHandler == 'function') {
						this.settings.onChangeHandler(val)
					}
				}
			},
			dropdownOptions() {
				if (!this.settings.dropdownOptions) return
				var sett = this.settings.dropdownOptions
				sett.disable = this.localDisabled
				if (sett.formName)
					sett.buttons = []
				return sett
			},
			localDisabled() {
				return this.componentMounted && this.dropdownData.length === 1 && (this.dropdownData[0].id === this.localValue?.id || !this.localValue)
			},
			isDisable() {
				return this.disabled || this.localDisabled
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.extend({}, this.settings, val)
				}
			},
			data: {
				immediate: true,
				deep: true,
				handler(val) {
					if (val)
						this.setDropdownData(val)
					else {
						this.setDropdownData(this.account_leaves)
					}
				}
			},
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (!_.isEqual(val, this.localValue)) {
						this.dropdownValue = val
						return
					}

					if (!val) {
						this.dropdownValue = null
					}
				}
			}
		},
		created() {
			this.localValue = this.modelValue
			this.settings.dropdownOptions = { ...this.settings.dropdownOptions, ...this.getDropDownOptions() }
		},
		mounted() {
			this.componentMounted = true
			this.getToursList()
		},
		methods: {
			updateModelValue(val) {
				this.dropdownValue = val
			},
			setDropdownData(accounts) {
				this.dropdownData = []
			},
			getDropDownOptions() {
				return {
					rowIdentifier: 'id',
					searchable: true,
					required: false,
					remoteSearch: false,
					placeholder: this.$t('search'),
					display: (item) => {
						if (!item) return ''
						if (Array.isArray(item)) {
							return item.map(x => `${x.name} (${x.code})`).join(', ')
						}
						return `${item.name} (${item.code})`
					},
					searchableFields: ['code', 'name'],
					dropdown: {
						selectorWidth: 420,
						selectorHeight: this.selectorHeight,
						display: (item) => {
							if (!item) return ''
							return `${item.name} (${item.code})`
						},
						searchableFields: ['code', 'name'],
						component: {
							type: 'ag-grid',
							options: {
								id: this.$options.name,
								columnDefs: [
									{
										field: 'code',
										headerName: this.$t('capillary.tour.f.code'),
										contentType: 'string',
										cellClass: 'text-center',
										headerClass: ' text-center',
									},
									{
										field: 'name',
										headerName: this.$t('capillary.tour.f.name'),
										contentType: 'string',
										cellClass: 'text-center',
										headerClass: ' text-center',
									},
									{
										field: 'startDate',
										headerName: this.$t('capillary.tour.f.startDate'),
										contentType: 'date',
										cellClass: 'text-center',
										headerClass: ' text-center',
									},
								],
								rowSelection: {
									mode: 'multiRow',
									checkboxes: true,
									headerCheckbox: true
								},
								cellSelectionAggReport: false,
								sideBar: 'none',
								enterToSelect: true,
								doubleClickedToSelect: true,
								pagination: false,
								fitToWidth: false,
								checkSelectedOnModelValueChange: true
							}
						},
						buttons: []
					}
				}
			},
			getToursList() {
				const wait = this.$wait(this.$el)
				post(Endpoints.getUrl('tour.list'), {})
					.then((res) => {
						this.toursList = res.data ?? []
					})
					.finally(() => {
						wait.end()
					})
			},
			showTourList() {
				this.showModal({
					component: TourList,
					options: {
						type: this.settings.type
					}
				})
					.then((res) => {
						if (this.$refs.dropdown)
							this.$refs.dropdown.$el.focus()
					})
					.catch(err => {
						if (this.$refs.dropdown)
							this.$refs.dropdown.$el.focus()
					})
			},
			showTourModify() {
				this.showModal({
					component: TourModify,
					data: null,
					options: {
						type: this.settings.type
					}
				})
					.then((res) => {
						if (this.$refs.dropdown)
							this.$refs.dropdown.$el.focus()

						this.getToursList()
					}).catch(err => {
						if (this.$refs.dropdown)
							this.$refs.dropdown.$el.focus()
					})
			},
		}
	}
</script>
<style></style>
